import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { StepState as StepStateOptions } from '../form-step.type';



import * as _ from 'lodash-es';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { f3Animations } from '@f3/animations';
import { Step } from '../form-step.type';
import { CasualHireFormService } from '../casual-hire-form.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';


@Component({
    selector: 'hire-form-form-stepper',
    templateUrl: './form-stepper.component.html',
    styleUrls: ['./form-stepper.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: f3Animations,
    standalone: true,
    imports: [NgClass, FaIconComponent]
})
export class FormStepperComponent implements OnInit, OnDestroy {

    // @Public Properties
    public steps: Step[] = [];

    public StepStateOptions = StepStateOptions;

    // @Private Properties
    private _unsubscribeAll: Subject<any> = new Subject;


    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        private _casuralHireFormService: CasualHireFormService,
        private _router: Router
    ) { }


    //--------------------------------------------------------------------------------
    // @Lifecycle Hooks
    //--------------------------------------------------------------------------------

    ngOnInit() {

        //subscibe to the steps from the service
        this._casuralHireFormService.steps$.pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe({
            next: (steps: Step[]) => {
                this.steps = steps;
                this._changeDetectorRef.markForCheck()
            }
        })

        
    }

    /**
     * OnDestroy
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete()
    }


    //--------------------------------------------------------------------------------
    // @Public Methods
    //--------------------------------------------------------------------------------

    /**
     * get the step class
     */
    public getStepClass(id: any): string {
        const step = this.steps.find(step => step.id === id)

        if(!step) return '';

		let retClass = '';
		switch(step.state) {
			case StepStateOptions.COMPLETED :
				retClass = 'bg-gwc-blue-700';
				break;
			case StepStateOptions.INPROGRESS :
				retClass = 'bg-gwc-blue-400';
				break;
			case StepStateOptions.UNCOMPLETED :
			default :
    			retClass = 'bg-slate-300';
				break;
		}

		return retClass;
	}

    /**
     * Step is clicked
     */
    public stepClicked(id: string) {
        if(!this.isClickable(id)) return;

        this._router.navigate([this.steps.find(step => step.id === id)?.slug], { relativeTo: this._activatedRoute })
    }

    /**
     * Is the item clickable?
     */
    public isClickable(id: string) {
        return !this._isOrderConfirmationPage() && this.steps.find(step => step.id === id)?.state === StepStateOptions.COMPLETED
    }

    /**
     * Are the steps finished
     */
    public areStepsFinished() {
        //determine whether all the steps are completed by getting the completed ones and matching to the total length
        return this.steps.filter(step => step.state === StepStateOptions.COMPLETED).length === this.steps.length
    }



    //--------------------------------------------------------------------------------
    // @Private Methods
    //--------------------------------------------------------------------------------

    private _isOrderConfirmationPage() {
        return false;
        // return this._formStepperService.OrderConfirmationPage;
    }

}
